// extracted by mini-css-extract-plugin
module.exports = {"vr":"VrContainer_vr__dSF2N","container":"VrContainer_container__VjAaa"};